import en_US_messages from "@/i18n/en_US.json"

import {
  fromReactIntl, toReactIntl 
} from "@/util/formatLocale"
import {
  IntlProvider 
} from "react-intl"

const messageMap = {
  en_US: en_US_messages,
}

const LocaleProvider = (props) => {
  const language = toReactIntl("en_US")

  const locale = fromReactIntl(language)

  const messages = messageMap[locale]

  const handleIntlError = (error) => {
    console.error(error)
  }

  return (
    <IntlProvider
      key={language}
      {...props}
      defaultLocale={process.env.NEXT_PUBLIC_DEFAULT_LOCALE}
      locale={language}
      messages={messages}
      onError={handleIntlError}
    />
  )
}

export default LocaleProvider
